import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>Effective Date: 26th December 2024</p>
      <p>
        Thank you for using Rice Reviews. Your privacy is important to us. This
        Privacy Policy outlines how we collect, use, and protect your personal
        information when you use our restaurant discovery app, which features a
        scrollable video interface and interactive map functionality.
      </p>
      <h2>1. Information We Collect</h2>
      <h3>1.1 Personal Information Provided by You:</h3>
      <ul>
        <li>Account details: Name, email address, username, and password.</li>
        <li>
          Profile information: Photos, bio, and other details you choose to
          share.
        </li>
      </ul>
      <h3>1.2 Automatically Collected Information:</h3>
      <ul>
        <li>
          Location data: Precise location information to recommend nearby
          restaurants.
        </li>
        <li>
          Usage data: Information about how you interact with the App, including
          features used, videos watched, and review interactions.
        </li>
      </ul>
      <h3>1.3 Content You Create:</h3>
      <ul>
        <li>
          Videos: Recordings you create and upload to share restaurant reviews.
        </li>
        <li>
          Comments and reviews: Any text or interactions you post within the
          App.
        </li>
      </ul>
      <h3>1.4 Permissions Requested:</h3>
      <ul>
        <li>Location: To provide personalized restaurant recommendations.</li>
        <li>Camera and Microphone: To enable video recording and uploads.</li>
        <li>Storage: To save and upload content.</li>
      </ul>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Provide and improve the App's features and functionality.</li>
        <li>Recommend restaurants based on your location and preferences.</li>
        <li>
          Build and display user profiles to allow others to follow your
          activity and recommendations.
        </li>
        <li>
          Send notifications, updates, and marketing communications (with your
          consent).
        </li>
      </ul>
      <h2>3. Sharing Your Information</h2>
      <ul>
        <li>
          With Other Users: Profile information, reviews, and videos you upload
          will be visible to other users.
        </li>
        <li>
          With Service Providers: Trusted third parties that assist in operating
          the App (e.g., hosting, analytics).
        </li>
        <li>
          As Required by Law: To comply with legal obligations or respond to
          lawful requests.
        </li>
      </ul>
      <h2>4. Your Choices and Controls</h2>
      <p>
        You can manage or disable location services through your device
        settings.
      </p>
      <h2>5. Data Security</h2>
      <p>
        We implement reasonable security measures to protect your information
        from unauthorized access, loss, or misuse.
      </p>
      <h2>6. Children's Privacy</h2>
      <p>
        The App is not intended for use by individuals under the age of 13. We
        do not knowingly collect personal information from children.
      </p>
      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        effective upon posting the updated policy in the App.
      </p>
      <h2>8. Contact Us</h2>
      <p>
        If you have any questions or concerns, please contact us at:
        <br />
        Rice Reviews LLC <br />
        800 N King Street Suite 304 2918 Wilmington, DE 19801 United States{' '}
        <br />
        contact@ricereviews.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;
